export default __webpack_public_path__ + "overdue-20.png";